var _polygon, _polygon2, _polygon3, _polygon4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 0 63 18 63 18 18 63 18 63 0 0 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 0 81 0 81 18 126 18 126 63 144 63 144 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "144 144 144 81 126 81 126 126 81 126 81 144 144 144"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 144 63 144 63 126 18 126 18 81 0 81 0 144"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 64.8,
    width: 72,
    height: 14.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMinus);
export default __webpack_public_path__ + "static/media/btn_minus.0eb06ccc218c4528a7b8fd0eaf94f364.svg";
export { ForwardRef as ReactComponent };